import React, {memo} from "react";

export const IconAnotherMember = memo(({color}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <circle cx="24" cy="24" r="20" fill="white" />
      </g>
      <path
        d="M15.7916 23.28H16.2956C16.4982 23.28 16.6662 23.2533 16.7996 23.2C16.9329 23.1413 17.0476 23.0507 17.1436 22.928L20.3356 18.888C20.4689 18.7173 20.6076 18.6 20.7516 18.536C20.9009 18.4667 21.0876 18.432 21.3116 18.432H23.1676L19.2716 23.24C19.0422 23.5333 18.8049 23.7413 18.5596 23.864C18.7356 23.928 18.8929 24.0187 19.0316 24.136C19.1756 24.248 19.3116 24.3973 19.4396 24.584L23.4556 30H21.5596C21.3036 30 21.1116 29.9653 20.9836 29.896C20.8609 29.8213 20.7569 29.7147 20.6716 29.576L17.3996 25.304C17.2982 25.16 17.1809 25.0587 17.0476 25C16.9142 24.9413 16.7222 24.912 16.4716 24.912H15.7916V30H13.6396V18.432H15.7916V23.28ZM34.3603 18.432V30H32.2003V24.944H26.7683V30H24.6083V18.432H26.7683V23.408H32.2003V18.432H34.3603Z"
        fill={color || "#000"}
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
});
